import * as React from "react";

import { useGetContractFamilyPipelineConfigurationQuery } from "@/api/contract-family-pipeline";
import type { PipelineExecutionMode } from "@/types/contract-family-pipeline";

/**
 * Starts from the organisation's execution mode for one-click summaries and remembers the
 * user's own choice while the dialog is open. Until the configuration has loaded and the user
 * has not chosen, no mode is sent so the backend applies the organisation default.
 */
export const useBatchApiChoice = (open: boolean) => {
  const configuration = useGetContractFamilyPipelineConfigurationQuery(undefined, { skip: !open });
  const [choice, setChoice] = React.useState<boolean | null>(null);

  React.useEffect(() => {
    if (open) setChoice(null);
  }, [open]);

  const useBatchApi = choice ?? configuration.data?.auto_execution_mode === "batch";
  const executionMode: PipelineExecutionMode | undefined =
    choice === null && !configuration.data ? undefined : useBatchApi ? "batch" : "sync";

  return { useBatchApi, setUseBatchApi: setChoice, executionMode };
};
